import Hook from "../utils/hook"
import loadScript from "../utils/load-script"

const SCRIPT_URL = `https://map.naturkartan.se/embed.js`

// the embedded map (naturkartan-maps-react); while signed in, it and the save
// modal (`SiteSaveModal`) tell each other when a site was saved or unsaved, so
// both reload the saved sites
export default Hook(`Map`, {
  refs: [`siteSaveModal`],
  values: { customPin: String },
  actions: [
    {
      name: `receive`,
      type: `naturkartanReceive`,
    },
  ],

  mounted() {
    this.receiveHandlers = new Set()
    this.defaultQuery = this.el.dataset.naturkartanQuery
    this.loaded = false
    this.injectedCustomPin = null

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.observer.disconnect()
        this.load()
      }
    })
    this.observer.observe(this.el)
  },

  destroyed() {
    this.observer.disconnect()
    this.receiveHandlers.clear()
    if (this.siteSaveModalRef) this.siteSaveModalRef.removeMap(this)
  },

  siteSaveModalRefMounted(ref) {
    ref.addMap(this)
  },

  siteSaveModalRefDestroyed(ref) {
    ref.removeMap(this)
  },

  load() {
    // the embed reads `data-naturkartan-*` params (incl. `custom-pin`) when injected
    this.injectedCustomPin = this.customPinValue

    if (window.NATURKARTAN_MAP) window.NATURKARTAN_MAP.inject(this.el)
    else
      loadScript(SCRIPT_URL).then(() => window.NATURKARTAN_MAP.inject(this.el))
  },

  addReceiveHandler(fn) {
    this.receiveHandlers.add(fn)
  },

  removeReceiveHandler(fn) {
    this.receiveHandlers.delete(fn)
  },

  receiveAction(e) {
    if (e.detail.method === `loaded`) this.mapLoaded()

    this.receiveHandlers.forEach((fn) => fn(e.detail))

    switch (e.detail.method) {
      case `savedSitesChanged`: {
        this.siteSaveModalRef?.mapSavedSitesChanged(e.detail.data)
        break
      }

      case `siteViewed`: {
        // this.receivedSiteViewed(e.detail.data)
        break
      }
    }
  },

  mapLoaded() {
    this.loaded = true

    // the pin changed while the embed was loading, after it read its params
    if (this.customPinValue !== this.injectedCustomPin)
      this.sendCustomPin(this.customPinValue)
  },

  customPinValueChanged(value) {
    // not loaded yet: the embed reads `data-naturkartan-custom-pin` itself
    if (this.loaded) this.sendCustomPin(value)
  },

  sendCustomPin(value) {
    if (!value) return
    const { lat, lng, title } = Object.fromEntries(new URLSearchParams(value))
    this.send(`setCustomPin`, { lat, lng, title })
  },

  send(method, data) {
    this.el.dispatchEvent(
      new CustomEvent(`naturkartanSend`, { detail: { method, data } })
    )
  },

  // not loaded yet: the map fetches the saved sites itself as it loads
  sendSavedSitesChanged() {
    if (this.loaded) this.send(`savedSitesChanged`)
  },

  setFullscreen(value) {
    this.send(`setFullscreen`, value)

    return new Promise((resolve) => window.setTimeout(resolve, 300))
  },

  setQuery(query) {
    this.send(`setQuery`, query)
  },

  setQueryWithDefault(query, { removeImportance = true } = {}) {
    let newQuery = [this.defaultQuery, query].filter(Boolean).join(`&`)

    if (removeImportance)
      newQuery = newQuery
        .split(`&`)
        .filter((q) => !q.includes(`importance=`))
        .join(`&`)

    this.setQuery(newQuery)
  },

  // receivedSiteViewed(site) {
  // },
})
